import Checkbox from "@vfuk/core-checkbox/";
import Container from "@vfuk/core-container";
import { GridColumn, GridRow } from "@vfuk/core-grid";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";

import { Stack } from "../Stack";
import {
  ContainerDisableRounded,
  HeadersContainer,
  TableHeader,
} from "./StyledContainers";
import { TableHeaderArrows } from "./TableHeaderArrows";
import classes from "./TableHeaderRow.module.scss";
import { SortDirection } from "./types";

type TableHeaderRowProps = {
  headers: Array<string>;
  sortableHeaderIndices?: Array<number>;
  headerSorting?: { index: number; direction: SortDirection };
  onColumnSortClick?: ({
    index,
    direction,
  }: {
    index: number;
    direction: SortDirection;
  }) => void;
  checked?: boolean;
  showCheckboxes?: boolean;
  onCheck?: (checked: boolean) => void;
  noMargin?: boolean;
  noRounded?: boolean;
  gridTemplateColumns?: string;
  flatStyle?: boolean;
};

export const TableHeaderRow = ({
  headers,
  sortableHeaderIndices,
  noMargin,
  noRounded,
  checked = false,
  showCheckboxes = false,
  headerSorting = { index: 0, direction: SortDirection.ASC },
  onColumnSortClick,
  onCheck,
  gridTemplateColumns,
  flatStyle,
}: TableHeaderRowProps): JSX.Element => (
  <GridRow marginBottom={noMargin ? 0 : 3} marginTop={noMargin ? 0 : 3}>
    <GridColumn>
      <div className={classes.HeaderRowContainer} role="row">
        <ContainerDisableRounded noRounded={noRounded ? true : false}>
          <Container paddingLevel={0} allowOverflow={false} zIndex={0}>
            <div
              className={
                onCheck
                  ? flatStyle
                    ? classes.HeaderRowCheckbox__flat
                    : classes.HeaderRowCheckbox
                  : flatStyle
                    ? classes.HeaderRowNoCheckbox__flat
                    : classes.HeaderRowNoCheckbox
              }
            >
              {onCheck && (
                <div className={classes.Clear}>
                  <Spacing spacingLevel={{ top: 2, bottom: 2 }}>
                    <Paragraph size={2} weight={2}>
                      {showCheckboxes && ( // Checking the user permissions to show the checkbox or not in the header
                        <Checkbox
                          value=""
                          id={`checkbox-header`}
                          name={`checkbox-header}`}
                          checked={checked}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            onCheck(e.target.checked)
                          }
                        >
                          {null}
                        </Checkbox>
                      )}
                    </Paragraph>
                  </Spacing>
                </div>
              )}

              <HeadersContainer gridTemplateColumns={gridTemplateColumns}>
                {headers.map((header, index) => {
                  // The header is only sortable if ...
                  const isHeaderSortable =
                    sortableHeaderIndices &&
                    sortableHeaderIndices?.length > 0 &&
                    sortableHeaderIndices?.indexOf(index) !== -1;
                  return (
                    <Spacing
                      key={`table-header${header}-${index}`}
                      spacingLevel={{ top: 2, bottom: 2 }}
                    >
                      <Stack align="center">
                        <TableHeader>{header}</TableHeader>
                        {isHeaderSortable && (
                          <TableHeaderArrows
                            key={`table-header-arrow${header}-${index}`}
                            alwaysVisible={headerSorting.index === index}
                            defaultDirection={
                              headerSorting.index === index
                                ? headerSorting.direction
                                : SortDirection.NONE
                            }
                            onClick={(direction) =>
                              onColumnSortClick?.({ index, direction })
                            }
                          />
                        )}
                      </Stack>
                    </Spacing>
                  );
                })}
              </HeadersContainer>
            </div>
          </Container>
        </ContainerDisableRounded>
      </div>
    </GridColumn>
  </GridRow>
);
